// src/categories/fasting.js
const KEY = "fasting";
const TITLE = "Fasting Sensations";
const SUBTITLE = "An Empty Belly Sensation";
const MAINWORD = "Empty Belly";
const MAINWORDS = "empty bellies";
const MIN_ONLINE = 5;
const MAX_ONLINE = 21;



const SENSATIONS = [
  "TASTE OF SALIVA IN EMPTY STOMACH",
  "TASTE OF FOOD IN MY MOUTH",
  "WARM EMPTINESS IN MY BELLY",
  "A GENTLE HOLLOW",
  "A SOFT PRESSURE ON MY STOMACH",
  "A LIGHT TICKLE ON MY TONGUE",
  "A SUBTLE SWEETNESS",
  "A COOL SENSATION AT THE BACK OF MY THROAT",
  "A SLIGHT NIBBLE",
  "PSYCHOLOGICAL TEMPTATION TO EAT",
  "A PULLING SENSATION UNDER RIBS",
  "A RISING WAVE FROM STOMACH",
  "SALIVA GATHERING",
  "A LIGHT BUZZ IN MY HEAD",
  "A LOW HUM IN MY CHEST",
  "A DROP IN ENERGY",
  "A SLIGHT DIZZINESS",
  "A RUMBLING STOMACH",
  "ANTICIPATION FOR FOOD",
  "RESTLESSNESS",
  "YEARNING FOR COMFORT",
  "TIGHTNESS AROUND THE BELLY",
  "A FLOATING, AIRY FEEL",
  "A WARM CENTER",
  "A GENTLE TINGLING",
  "A QUIET LONGING",
  "A SOFT SQUEEZE",
  "A GENTLE TIREDNESS",
  "A MEMORY OF TASTE",
  "A CALM HUNGER",
  "LOW MENTAL FOCUS",
  "A SLIGHT HEADACHE",
  "A GENTLE YEARNING",
];

const DISH_NAMES = {
  "TASTE OF SALIVA IN EMPTY STOMACH": "Saliva Taste",
  "TASTE OF FOOD IN MY MOUTH": "Food Memory",
  "WARM EMPTINESS IN MY BELLY": "Warm Emptiness",
  "A GENTLE HOLLOW": "Gentle Hollow",
  "A SOFT PRESSURE ON MY STOMACH": "Soft Pressure",
  "A LIGHT TICKLE ON MY TONGUE": "Tongue Tickle",
  "A SUBTLE SWEETNESS": "Subtle Sweetness",
  "A COOL SENSATION AT THE BACK OF MY THROAT": "Cool Throat",
  "A SLIGHT NIBBLE": "Slight Nibble",
  "PSYCHOLOGICAL TEMPTATION TO EAT": "Temptation",
  "A PULLING SENSATION UNDER RIBS": "Rib Pull",
  "A RISING WAVE FROM STOMACH": "Rising Wave",
  "SALIVA GATHERING": "Saliva Gather",
  "A LIGHT BUZZ IN MY HEAD": "Light Buzz",
  "A LOW HUM IN MY CHEST": "Low Hum",
  "A DROP IN ENERGY": "Energy Dip",
  "A SLIGHT DIZZINESS": "Slight Dizziness",
  "A RUMBLING STOMACH": "Rumbling",
  "ANTICIPATION FOR FOOD": "Anticipation",
  "RESTLESSNESS": "Restless",
  "YEARNING FOR COMFORT": "Comfort Yearning",
  "TIGHTNESS AROUND THE BELLY": "Belly Tightness",
  "A FLOATING, AIRY FEEL": "Airy Feeling",
  "A WARM CENTER": "Warm Center",
  "A GENTLE TINGLING": "Gentle Tingle",
  "A QUIET LONGING": "Quiet Longing",
  "A SOFT SQUEEZE": "Soft Squeeze",
  "A GENTLE TIREDNESS": "Gentle Tiredness",
  "A MEMORY OF TASTE": "Taste Memory",
  "A CALM HUNGER": "Calm Hunger",
  "LOW MENTAL FOCUS": "Low Focus",
  "A SLIGHT HEADACHE": "Slight Headache",
  "A GENTLE YEARNING": "Gentle Yearning",
};

const ENCOURAGEMENTS = {
 "RUMBLING STOMACH":
    "Those rumblings are your migrating motor complex clearing your digestive tract. It means your fast is working beautifully.",

  "FEAR OF FAILURE":
    "This feeling is just your survival brain reacting to change. It fades as your body adapts and your confidence builds.",

  "WARMTH AROUND TOP OF BELLY":
    "That warmth is blood flow shifting while your stomach rests. It’s a gentle sign your body is settling into the fast.",

  "BLOOD PRESSURE LOWERING":
    "A light drop in pressure can happen as insulin falls. Slow movements and electrolytes help your system stay balanced.",

  "BODY SHIVERING":
    "Shivers are your metabolism adjusting as you switch fuel sources. Warming up gently helps your body stay comfortable.",

  "LOSS OF APPETITE":
    "This is a classic fasting milestone — ghrelin dips and your body finds calm. Your appetite will return naturally when it’s time.",

  "TASTE OF SALIVA IN EMPTY STOMACH":
    "Your digestion is shifting gears. Saliva rises naturally when you’re not eating.",
  
  "TASTE OF FOOD IN MY MOUTH":
    "That's your brain releasing memory signals. Your brain is replaying food cues, completely normal.",
  
  "WARM EMPTINESS IN MY BELLY":
    "That’s blood flow redistributing. Your digestive system is resting.",
  
  "A GENTLE HOLLOW":
    "That’s your stomach relaxing. This is a normal fasting signal.",
  
  "A SOFT PRESSURE ON MY STOMACH":
    "That's your stomach contracting lightly between digestion cycles.",
  
  "A LIGHT TICKLE ON MY TONGUE":
    "That’s heightened taste sensitivity, fasting sharpens your senses.",
  
  "A SUBTLE SWEETNESS":
    "That’s either your saliva changing composition or ketones rising. This is normal.",
  
  "A COOL SENSATION AT THE BACK OF MY THROAT":
    "That’s vagus nerve activation, a calm-state response.",
  
  "A SLIGHT NIBBLE":
    "This is your hunger hormone pulsing, then fading.",
  
  "PSYCHOLOGICAL TEMPTATION TO EAT":
    "That’s your dopamine habit loop. It gets easier after a few minutes.",
  
  "A PULLING SENSATION UNDER RIBS":
    "That’s your stomach contracting gently between meals, completely normal.",
  
  "A RISING WAVE FROM STOMACH":
    "That's your ghrelin rising. It’s a sign your body is shifting into fat-mobilizing mode.",
  
  "SALIVA GATHERING":
    "That’s a natural ‘anticipation’ reflex. It doesn’t mean you need food.",
  
  "A LIGHT BUZZ IN MY HEAD":
    "This is increased adrenaline. It helps you stay alert and energized without food.",
  
  "A LOW HUM IN MY CHEST":
    "This is your nervous system adjusting into fasting mode.",
  
  "A DROP IN ENERGY":
    "This is your body switching fuels. Your glucose is dipping before fat-burning increases. Not harmful.",
  
  "A SLIGHT DIZZINESS":
    "This is mild blood pressure drop not low energy. It is common when fasting starts and usually temporary.",
  
  "A RUMBLING STOMACH":
    "This is your gut cleaning itself. This is called the MMC cycle.",
  
  "ANTICIPATION FOR FOOD":
    "This is habit memory triggering your reward pathways. It’s temporary and not true hunger.",
  
  "RESTLESSNESS":
    "This is your adrenaline rising. Your body is mobilizing energy.",
  
  "YEARNING FOR COMFORT":
    "This is emotional hunger, not physical need. It will pass.",
  
  "TIGHTNESS AROUND THE BELLY":
    "That’s your abdominal muscles responding to an empty stomach,  normal sensation.",
  
  "A FLOATING, AIRY FEEL":
    "This is a mild rise in your ketones. Your mind is clearing.",
  
  "A WARM CENTER":
    "This is your metabolism activating stored energy. It means increased fat use.",
  
  "A GENTLE TINGLING":
    "That’s nerve sensitivity increasing as digestion quiets down.",
  
  "A QUIET LONGING":
    "This is purely emotional memory or psychological hunger it's not a real need for food.",
  
  "A SOFT SQUEEZE":
    "That’s your stomach’s natural wave motion. It's normal.",
  
  "A GENTLE TIREDNESS":
    "This is your body conserving energy wisely. It's safe and expected.",
  
  "A MEMORY OF TASTE":
    "That's your brain replaying food memories. Not real hunger.",
  
  "A CALM HUNGER":
    "That’s your system stabilizing. Your hormones are adapting well.",
  
  "LOW MENTAL FOCUS":
    "This is your brain recalibrating. Keep going, focus will return as ketones rises.",
  
  "A SLIGHT HEADACHE":
    "This is from electrolyte shifts. Hydration and a bit of salt usually helps.",
  
  "A GENTLE YEARNING":
    "This is emotional hunger softening. Very safe to experience.",
};

export default { KEY, TITLE, MAINWORD, SUBTITLE, SENSATIONS, MAINWORDS, DISH_NAMES, MIN_ONLINE, MAX_ONLINE, ENCOURAGEMENTS };
